<template>
  <div id="app">
    <div v-if="isAbchina && !newAbcApp" class="store_top">
      <div class="store_top_lf" @click="gotoback">
        <img src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/h5-nc/return-btn.png">
      </div>
      <div class="store_top_title">违章代办</div>
      <div class="store_top_rt">

      </div>
    </div>
    <div v-if="(!advertisingShow)&&showApp" class="app">
      <img src="./assets/icon/input_cancel.jpg" @click="showApp=false" class="app-close">
      <p class="app-text"><img class="app-image" src="https://app.s4s.cn/h5vio/violation.png">下载齐车大圣App，便捷查违章 </p>
      <span class="app-btn" @click="getApp">立即使用</span>
      <a href="mys4sviolation://mys4s.cn" ref="mys4sviolation"></a>
    </div>
    <div class="notice" :style="showNotice?'max-height:110px;':'max-height:0;'">
      <div class="notice-content" @click="handleTapNotice">
        <div class="notice-text" :style="showNotice?'':'animation:none;'">
          {{noticeData.Title}}：{{noticeData.Alert}}
        </div>
      </div>
      <div class="notice-close" @click="handleCloseNotice">
        <img src="https://app.s4s.cn/razio/close.png" mode="widthFix" style="width:30rpx;height:30rpx;" />
      </div>
    </div>

    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <!-- <keep-alive include="login"> -->
      <router-view v-if="showRouter" />
    <!-- </keep-alive> -->
    <div class="foot grey"
    v-if="$route.path !== '/illegalPay'
    && $route.path !== '/ticketPay'
    && $route.path !== '/formWrap/ticketPay'
    && $route.path !== '/createOrder'
    && $route.path !== '/formWrap/createOrder'
    && $route.path !== '/formWrap/couponNow'
    && $route.path !== '/formWrap/illegalPay'
    && $route.path !== '/login'
    && $route.path !== '/help'
    && $route.path !== '/agreement'
    && $route.path !== '/carInfo'
    && $route.path !== '/carList'
    && $route.path !== '/order'
    && $route.path !== '/orderModify'
    && $route.path !== '/detail1'
    && $route.path !== '/detail2'
    && $route.path !== '/donthandle'
    && $route.path !== '/IndexAbchina'
    && $route.path !== '/addcar'"
    >
      <router-link class="menuitem" to="/"
        v-if="showIllegalTab"
      >
        <div class="menu-img">
          <img  v-if="activeName == '/'" src="./assets/icon/wei_sel.png"/>
          <img v-else  src="./assets/icon/wei.png"/>
        </div>
        <p :class="activeName == '/' ? 'black' : ''">查询</p>
      </router-link>
      <router-link class="menuitem" to="/ticket"
        v-if="showTicketTab">
        <div class="menu-img">
          <img v-if="activeName == '/ticket'" src="./assets/icon/fin_sel.png"/>
          <img v-else src="./assets/icon/fin.png"/>
        </div>
        <p :class="activeName == '/ticket' ? 'black' : ''">缴罚</p>
      </router-link>
      <router-link class="menuitem" to="/user">
        <div class="menu-img">
          <img v-if="activeName == '/user'" src="./assets/icon/user_sel.png"/>
          <img v-else src="./assets/icon/user.png"/>
        </div>
        <p :class="activeName == '/user' ? 'black' : ''">我的</p>
      </router-link>
    </div>
</div>
</template>
<script>
import CallApp from 'callapp-lib';
import advertisingShow from './utils/advertising';
import sha256 from 'crypto-js/sha256'
// import './utils/getQueryString'
require('./utils/upsdk')

export default {
  data() {
    return {
      isAbchina: false,
      showApp: false,
      activeName: this.$route.path,
      screenWidth: document.body.clientWidth,
      noticeData: {},
      showNotice: false,
      advertisingShow: advertisingShow(),
      showTicketTab: true,
      showIllegalTab: true, // 默认展示  违章 和 罚单 两个tab页面
      showRouter: false,
      newAbcApp: true, //5.5.0以上的ssssssss行app
    };
  },
  watch: {
    $route(val) {
      this.activeName = val.path;
      // console.log('efassadfadsfasdfasfasfsafasff',val)
      this.configTab(val.query.channel);
      if (val.query.key) { // 爱卡login
        window.localStorage.removeItem('s4s-vio-token');
        this.$store.commit('SET_TOKEN', '');
        this.aikaLogin(val.query.key);
      } else {
        this.showRouter = true;
      }
    },
    screenWidth(val) {
      this.screenWidth = val;
      if (this.screenWidth > 710) {
        const carno = this.$route.query.carno
          ? `carno=${this.$route.query.carno}`
          : '';
        const vin = this.$route.query.vin
          ? `&vin=${this.$route.query.vin}`
          : '';
        const engine = this.$route.query.engine
          ? `&engine=${this.$route.query.engine}`
          : '';
        const carType = this.$route.query.car_type
          ? `&car_type=${this.$route.query.car_type}`
          : '';
        const channel = this.$route.query.channel
          ? `&channel=${this.$route.query.channel}`
          : '';
        let url = 'https://mys4s.cn/static/vio/pc/index.html#/';
        if (window.localStorage.grey) {
          url = 'https://mys4s.cn/grey/static/vio/pc/index.html#/';
        }

        if (this.detect() === 'ios' || this.detect() === 'android') {
          return;
        }
        window.location.href = carno
          ? `${url}?${carno}${vin}${engine}${carType}${channel}`
          : url;
      }
    },
  },
  created() {
    // _czc.push(['_trackEvent', 'channel', 'form', this.$route.query.channel + '','1','']); //eslint-disable-line
    if (this.$route.query.channel) {
      try {
        window.localStorage.setItem('advertising', this.$route.query.channel);
        this.advertisingShow = advertisingShow();
      } catch (e) {
        console.log(e);
      }
    }
    if (this.$route.query.key) { // 爱卡login
      this.aikaLogin(this.$route.query.key);
    } else {
      this.showRouter = true;
    }
  },
  mounted() {
    if(window.navigator.userAgent.indexOf('Bankabc/Portal') != -1) {//1. 判断是否在sssss行app新容器
      this.newAbcApp = true
      const closeIconBase64 = "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgI QAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAUGVYSWZNTQAqAAAACAACARIAAwAAAAEAAQAAh2kABAAA AAEAAAAmAAAAAAADoAEAAwAAAAEAAQAAoAIABAAAAAEAAAAooAMABAAAAAEAAAAoAAAAAGg7SLIAAAIwaVRYdF hNTDpjb20uYWRvYmUueG1wAAAAAAA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRr PSJYTVAgQ29yZSA1LjQuMCI+CiAgIDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS 8wMi8yMi1yZGYtc3ludGF4LW5zIyI+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICAg ICAgICAgIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIgogICAgICAgICAgICB4bW xuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0 aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgICAgIDxleGlmOkNvbG9yU3BhY2U+MTwvZXhpZjpDb2xvcl NwYWNlPgogICAgICAgICA8ZXhpZjpQaXhlbFhEaW1lbnNpb24+NTA8L2V4aWY6UGl4ZWxYRGltZW5zaW9uPgog ICAgICAgICA8ZXhpZjpQaXhlbFlEaW1lbnNpb24+NTA8L2V4aWY6UGl4ZWxZRGltZW5zaW9uPgogICAgICA8L3 JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KtrIrXQAABlpJREFUWAndmH9InVUY x3evV6euzJizFFZsUX9YW3+4yyJkDbVhRblV2+jHgkH5YytWZBQV5R8tSAIV82dCWURsLWoRNBZKIVqUQq5iFc Gsltdfa4FDbf7q8xzf8+7c977v9XU6gl547/Oc5zw/vuc5zznnPTewYpmekpKS1FAolD03N5cVCARmeEZSUlJG ampq/l5KiMDFGu/bt2/t7OxsMYC2827CzxVuvgB7uLm5ebdbnx/ZogGWlpYWAagS55t9BQgEzmRlZWVWVlbO+t F36vgGWF5enkvGqgCX73AySvs47ymyNcAbQS8EXYPsct52MtgDjXkOHDhw1eTk5Bt0bMPvcDAYPNjU1PS2qegL IFl7FqNXcRIUY4JPQFp5jxQUFHTt2rVrRuSLfajbTmzyTLuEhIQ7GxsbP9OyuACZluRIJPImwB4WA4DJNLUlJS W9VFdXd1o7uRi6f//+a6empvqdtsR4j4yreNIXcirotoAbGBj4nLYaIYaDTMEORve11lkKxZdX1qPkasrcApG5 VgNcLwA3LRc4iSczgE9JgPnMIXvLFLgClJpjWh8SRQx64bdQvH+ahsvBk8Xd+JFE/E6cHtr3EecL03dMDVqr9R trQUQwCl8KcCaIeHxMBq2tJMiIZllR9/6X4AR41CKxNuF8a0RtXjXHAgoODg5uZQB99fX1Z+JlwOzDfw4zEsLv CVMej4/KINNaKcpkb0K2Ei9DFlANmW5nm/iJvWyDl54pR+9R/P/AGd1HGd1h9jl5dBO1zAaI8BqEm62O1gX2uR stvQxoBwE3Wm1XIuDoaOFVNc/gtH2MPlmWc/0s9EuZKRsgqb/H0D5i8DEsuk+RZT21GWSl3QukExzOuimNphin FwQ3w66SnWN4eHijDRDBdktnVI6vC/qxnFVDBQuBdAOXnp5e1NDQcC7W67wE8L26b3p6eqsNEGHY6jju52zlOO pD3xOkF7iqqqoxDcCNZmZmnmDgZ6UPukUBrKiokJSmWQan3AzdZF4gAfcy+nbNwXdL5hYCJzGou1mwqFUOXacA jo+PZ0mnPKAemOf8/bqBxFIA6kPANzgdEQwjwkPXKIAgNQFGtKJfqkGir2tLg/vOb+YcseQbU54MBZBVeH6+rX 5XGrxvlkFKDa8yDcjA2rGxsXWmzCefLHr4nFAAuezY04ow26cTW81lQUxZAVbH24JsBw5GY5ByUwBZzoPozFl6 9nQ77FybLuC6ExMTb8O5r33SzSm2OkkRBbClpWUK4ZAog95zl3c6cwMnNcf5/BW6nluQ04/ZZhUng2G9yKCnFU Cr0SEUoPlcKS8TPt7jBU5vJXrhLDaTfIQUEjdVYmPbYQPk+DoqQlCvpG6KhPd6APcgfS28erW6biVeILG/zss3 8fWJNpOamvqpDTAtLU1uUuctw0e8HIickT0hxNJxBWf1rXADib36Wtc6mlozpwCi01ldXf2XDVCmBuHHoswo7k b5Vm3opPTLYT+O/jE/+5wGiY3cnf/A/rDTp7SZuWfoW231vSNUZ0HJuArewIr+ESW5eHfhWN3oLIMoQjEn8eqM R/V5NdAP5uTkBNzOehJyNbF/xVb20pOFhYUbRC8KoDimPhog5cLzPM4Kr59nL90vCQmUlZV9BC2WKHzRFPPF9I ninWHz8vJ6SPVe5KlkcVs4HO7q6enx/QHh9OenPTQ0dBBwj4kuMdu5B72g7ewa1ILa2tohlHeiOA0N8fX7AaO7 SfcvN+XLeS8xnhe/xOznqvGAGSPBbGi+t7e3Pzc3Vw7su3hTALqHTH5PJn/ROkul+AxYmXtdfAHuHFvd7WzyUb MVU4NmYOrxFdoq3TiQ77TK7Ozs1xa7OEyfwsuCoIya8KdqTsAh3smiPObUjQtQlJnePTiSP5D0V46M8EWcvY9j fX47/bq2ZZ+ztpKnUVBfPvjoJ3OyKFyvogsClEhciG7B8SFYufmpB8c/835I4yjOv/UCS7aT5fiizorR2cFA9T 6nFoTUHDfIEcttDPEFUKwkEP92yQkiBZ0uMuMZJfhvtAcAIH9iroRmQ+U/6/XI1dlq6J9kK3lObyWGPIb1DVBb ks0rycaTtO8neI6W+6AzAO7kfTc/P7/NbbN287FogKYTtojraUuhh3XG4LPg/4FGACMZlb/ZOuTgl7MV+f/r+R eLBP5pQAhzkgAAAABJRU5ErkJggg=="
      AlipayJSBridge.call('setOptionMenu', {
        menus: [{ icon: closeIconBase64, //“关闭”图标 Base64。40x40，周边不留白
        redDot: '-1', // -1 表示不显示，0 表示显示红点，1-99 表示在红点上显示的数字
        }],
        override: true // 是否覆盖默认的 optionMenu，统一传 true
      });
      AlipayJSBridge.call('showOptionMenu'); // 必须调用一次以刷新界面
    } else {
      this.newAbcApp = false
    }
    // 新ssss行app导航栏点击事件
    document.addEventListener('optionMenu', function(e) {
      if(e.data.index == 0) {
        // 用户点击了第一个图标。setOptionMenu 方法中，设置了第一个图标为“关闭”
        AlipayJSBridge.call('abcExitWebAndBackToHome');
      }
    }, false);

    this.showApp = true;
    this.configTab(this.$route.query.channel);

    if (this.$route.query.channel) {
      try {
        if (this.$route.query.channel === 'abchina') {
          this.isAbchina = true;
          // let abchinaToken = window.localStorage.getItem('abchina-token');
          const token = window.localStorage.getItem('s4s-vio-token');
          const access_token = this.$route.query.access_token;
          // if (!token || !access_token) {
          //   let state = Math.random();
          //   let redirect_uri = btoa(encodeURIComponent('https://mys4s.cn/static/vio/index.html#/ticket?channel=abchina&source=abchina'));
          //   const urlStr = 'https://www.abchina.com/luascript/oauthLogin/{"client_id":"7708e730-c9ac-48a5-b363-b0728ed068e5","closeCurrentH5":"YES","redirect_uri":"https://mys4s.cn/v5/auth/'+ redirect_uri +'","state":"'+ state +'","scope":"openid","response_type":"code"}';
          //   window.top.location.href = urlStr;
          // }
          // access_token = JSON.parse(abchinaToken);
          access_token && this.$store.commit('SET_USERINFO', {});
          access_token && this.$store.commit('SET_TOKEN', access_token);
        } else if (this.$route.query.channel === 'unionpay') {
          const urlStr = `https://open.95516.com/s/open/html/oauth.html?appId=fadb89f92b3643daab335556e2647ba3&redirectUri=${encodeURIComponent('https://mys4s.cn/static/vio/index.html#/ticket?channel=unionpay')}&responseType=code&scope=upapi_base`;
          const { code } = this.$route.query;

          if (!code) {
            window.top.location.href = urlStr;
          } else {

            this.$request('v5/unionpay/auth', { code }).then((xhr, res) => {
              this.$store.commit('SET_TOKEN', res.data.access_token);
              this.$store.commit('SET_USERINFO', {});
            });
            this.$request('v5/unionpay/upsdk', {}).then((xhr, res) => {
              function randomString(length, chars) {
                var result = '';
                for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
                return result;
              }

              var rString = randomString(16, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
              const time = Math.floor((new Date().getTime()) / 1000)
              // https://mys4s.cn/h5/h5_nc_test/index.html
              const sign = `appId=fadb89f92b3643daab335556e2647ba3&frontToken=${res.data.frontToken}&nonceStr=${rString}&timestamp=${time}&url=https://mys4s.cn/static/vio/index.html`

              const params = {
                appId: 'fadb89f92b3643daab335556e2647ba3',
                timestamp: time,
                nonceStr: rString,
                signature: sha256(sign).toString(),
                debug: false,
              }
              upsdk.config(params)
            })
          }
        }
        window.localStorage.setItem('viochannel', this.$route.query.channel);
        this.advertisingShow = advertisingShow();
      } catch (e) {
        console.log(e);
      }
    }
    // if (this.$route.query.channel === 'baidu_car'
    // || window.localStorage.viochannel === 'baidu_car') {
    //   this.showApp = false;
    // }
    // console.log(this.$route.path);
    // if (this.$route.path.indexOf('/pay') !== -1
    // || this.$route.path.indexOf('/car') !== -1) {
    //   try {
    //     window.localStorage.setItem('channel', 'uc');
    //   } catch (e) {
    //     console.log(e);
    //   }
    // }
    const self = this;
    window.onresize = () =>
      (() => {
        window.screenWidth = document.body.clientWidth;
        self.screenWidth = window.screenWidth;
      })();
    if (this.screenWidth > 710) {
      const carno = this.$route.query.carno
        ? `carno=${this.$route.query.carno}`
        : '';
      const vin = this.$route.query.vin ? `&vin=${this.$route.query.vin}` : '';
      const engine = this.$route.query.engine
        ? `&engine=${this.$route.query.engine}`
        : '';
      const carType = this.$route.query.car_type
        ? `&car_type=${this.$route.query.car_type}`
        : '';
      const channel = this.$route.query.channel
        ? `&channel=${this.$route.query.channel}`
        : '';
      let url = 'https://mys4s.cn/static/vio/pc/index.html#/';
      if (window.localStorage.grey) {
        url = 'https://mys4s.cn/grey/static/vio/pc/index.html#/';
      }
      if (this.detect() === 'ios' || this.detect() === 'android') {
        return;
      }
      window.location.href = carno
        ? `${url}?${carno}${vin}${engine}${carType}${channel}`
        : `${url}?${channel}`;
    }
    this.getCommonNotice();
  },
  methods: {
    configTab(channel) {
      const nowChannel = channel || window.localStorage.getItem('viochannel') || window.localStorage.getItem('advertising');
      const notShowTicketTab = ['xcarillegal', 'cmbapp']; //   这个数组里的channel 不展示  罚单tab页
      const notShowIllegalTab = ['xcarticket', 'abchina', '114h5', 'unionpay'];//   这个数组里的channel 不展示  违章tab页
      if (notShowTicketTab.indexOf(nowChannel) !== -1) {
        this.showTicketTab = false;
      } else {
        this.showTicketTab = true;
      }

      if (notShowIllegalTab.indexOf(nowChannel) !== -1) {
        this.showIllegalTab = false;
      } else {
        this.showIllegalTab = true;
      }
    },
    handleTapNotice() {
      if (this.noticeData.Type === 1) {
      // h5
        window.location.href = this.noticeData.Link;
      } else if (this.noticeData.Type === 3) {
      // tanchuang
        this.$showModal({
          title: this.noticeData.Title,
          content: this.noticeData.Alert,
          confirmText: '我知道了',
        });
      }
    },
    handleCloseNotice() {
      this.showNotice = false;
    },
    getCommonNotice() {
      this.$requestPost('v5/notify/query', {
        app: 'vio',
        channel: 'h5',
      }).then((xhr, res) => {
        console.log(res);
        if (res.code === 0 && res.data) {
          res.data.forEach((item) => {
            if (item.Tab === 'index' && item.Notify && item.Notify.Alert && item.Notify.Title) {
              setTimeout(() => {
                this.noticeData = item.Notify;
                this.showNotice = true;
              }, 1000);
              // console.log(item.Notify, 'item.Notifyitem.Notify');
            }
          });
        }
      });
    },
    getApp() {
      // _czc.push(['_trackEvent', 'app', 'click', 'illegal','打开app','']); //eslint-disable-line
      const options = {
        scheme: {
          protocol: 's4s://mys4s.cn',
        },
        intent: {
          package: 'com.qichedasheng.s4s',
          component: 'com.mys4s.traffictest.MainActivity',
          scheme: 's4s://mys4s.cn',
        },
        appstore: 'https://itunes.apple.com/cn/app/%E9%BD%90%E8%BD%A6%E5%A4%A7%E5%9C%A3/id1097885036?mt=8',
        yingyongbao: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.qichedasheng.s4s',
        fallback: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.qichedasheng.s4s',
      };
      const callLib = new CallApp(options);

      callLib.open({
        path: '',
      });
    },
    detect() {
      let equipmentType = '';
      const agent = navigator.userAgent.toLowerCase();
      const android = agent.indexOf('android');
      const iphone = agent.indexOf('iphone');
      const ipad = agent.indexOf('ipad');
      if (android !== -1) {
        equipmentType = 'android';
      }
      if (iphone !== -1 || ipad !== -1) {
        equipmentType = 'ios';
      }
      return equipmentType;
    },
    aikaLogin(key) {
      window.localStorage.removeItem('s4s-vio-token');
      this.$store.commit('SET_TOKEN', '');
      this.$store.commit('SET_CARLIST', []); // 切换用户后把车辆列表置空
      this.$request('v5/user/aika/login', { aika_token: key }).then((xhr, res) => {
        this.showRouter = true;
        if (res.code === 0) {
          // 登录成功
          this.$store.commit('SET_TOKEN', res.data.Token);
          this.$store.commit('SET_USERINFO', res.data.User);
          this.$store.dispatch('getCar').then(() => {});// 切换用户后把车辆列表置空 然后重新获取该用户的车辆列表
        } else {
          this.$showToast({
            title: res.msg,
          });
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    gotoback() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
@import "./assets/css/common.css";

.modal {
  position: fixed;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  transition: all .3s ease;
  &-bg {
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.4);
  }
  &-box {
    transition: all .3s ease;
    width: 280px;
    position: absolute;
    top: 40%;
    left: 50%;
    -webkit-transform: translate3d(-50%,-50%,0);
    transform: translate3d(-50%,-50%,0);
    background-color: #fff;
    border-radius: 2px;
    line-height: 1.5;
    text-align: center;
  }
  &-main {
    text-align: center;
    padding: 21px 19px 20px;
    color:#24252d;
    &-content {
      padding-top: 0;
      color:#5B5E6A;
    }
    &-title {
      font-size: 16px;
    }
  }
  &-button {
    overflow: hidden;
    border-top: 1px solid #EEE;
    font-size: 16px;
    line-height: 44px;
    display: flex;
  }
  &-confirm {
    &-cancel {

      color: #3A82FF;
      flex:1;
      border-right: 1px solid #EEE;
      margin-right: -1px;
    }
    &-button {
      flex:1;
      color: #3A82FF;
      border-right: .5px solid #eaeaea;
    }
  }
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.foot {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 50px;
  background: #fff;
  display: flex;
  z-index: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.menuitem {
  flex: 1 1;
  z-index: 999;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.menu-img {
  height: 21px;
  line-height: 21px;
  margin-bottom: 4px;
}
.menu-img img {
  width: 20px;
  height: 20px;
}
.menuitem p {
  font-size: 10px;
  line-height: 14px;
}

.app{
  z-index: 999;
  display:flex;
  align-items: center;
  // justify-content: space-around;
  background-color: #5E6984;
  font-size: 13px;
}
.app-text{
  display:flex;
  flex: 1;
  align-items: center;
  color: #fff;
  padding: 5px 0;
  margin-left: 8px;
}
.app-image{
  width: 30px;
  height: 30px;
  margin: 8px;
}
.app-close {
  width: 18px;
  height:18px;
  margin-left: 15px;
}

.app-btn {
  width: 70px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  color: #fff;
  border-radius: 6px;
  margin-right: 15px;
  border:1px solid rgba(255,255,255,1)
}
/*ssss行渠道定制的返回按钮 开始*/
.store_top{
    display: flex;
    justify-content:space-between;
    align-items:center;
    height:44px;
    line-height: 44px;
    padding: 0 16px 0;
    font-size: 0;
    background-color: #fff;
}
.store_top .store_top_title{
    font-size: 18px;
    font-family: "PingFangSC-Medium";
    color: #000;
    font-weight: bold;
}
.store_top_lf{
    width: 75px;
    height: 20px;
}
.store_top_rt{
    width: 75px;
    height: 25px;
}
.store_top_lf img{
    width: 20px;
    height: 20px;
}
.store_top_rt img{
    display: inline-block;
    width: 25px;
    height: 25px;
    margin-left: 10px;
}
/*ssssss行渠道定制的返回按钮 结束*/
</style>
